import { render, staticRenderFns } from "./Resetpassword.vue?vue&type=template&id=ca1976bc&scoped=true&"
import script from "./Resetpassword.vue?vue&type=script&lang=js&"
export * from "./Resetpassword.vue?vue&type=script&lang=js&"
import style0 from "./Resetpassword.vue?vue&type=style&index=0&id=ca1976bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1976bc",
  null
  
)

export default component.exports